<template>
  <v-row no-gutters justify="center">
    <circle-image-button
      v-if="canAnnotate"
      :active="isAnnotating"
      :image="coloredAssetUrls.annotate"
      title="Annotate Image"
      btnClass="primary"
      @click="$store.commit('toggleIsAnnotating')"/>
    <circle-image-button
      v-if="canDownload && !userIsViewOnly"
      :image="coloredAssetUrls.download"
      btnClass="primary"
      title="Download Image With Layers"
      @click="downloadImage()"/>
    <circle-image-button
      v-if="!userIsViewOnly"
      title="Print Image"
      :image="coloredAssetUrls.print"
      btnClass="primary"
      @click="openPrintPreview([currentBrowserImage])"/>
    <circle-image-button
      v-if="(!ssoEmrPro || enableSavingWithEmrPro) && isAnnotating && canAnnotate && !userIsViewOnly"
      title="Save Image With Layers"
      btnClass="primary"
      :image="coloredAssetUrls.save"
      @click="saveImage"/>
    <circle-image-button
      v-if="isAnnotating && canAnnotate"
      title="Reset Image"
      :image="coloredAssetUrls.reset"
      btnClass="primary"
      @click="resetImage"/>
    <circle-image-button
      v-if="isAnnotating && canAnnotate"
      title="Clear All Annotations"
      :image="coloredAssetUrls.clear"
      btnClass="primary"
      @click="clearAnnotations()"/>
  </v-row>
</template>

<script>
import circleImageButton from "../../controls/CircleImageButton";
import imageAnnotationHelper from "../../mixins/ImageAnnotationHelper";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { circleImageButton },
  mixins: [imageAnnotationHelper],
  props: {
    context: Object
  },
  computed: {
    ...mapGetters([
      "isAnnotating",
      "ptSrNo",
      "currentBrowserImage",
      "canAnnotate",
      "canDownload",
      "ssoEmrPro",
      "userIsViewOnly",
      "enableSavingWithEmrPro"
    ]),
    annotationButtonImage() {
      return this.isAnnotating
        ? "White Icons/annotate-white-icon.png"
        : this.coloredAssetUrls.annotate;
    }
  },
  methods: {
    ...mapActions(["openPrintPreview"])
  }
};
</script>
